import { render } from "./faqs-categories.vue?vue&type=template&id=6eefc8be"
import script from "./faqs-categories.vue?vue&type=script&lang=js"
export * from "./faqs-categories.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__